<template>
    <div id="app"> <!-- Considera si este id="app" es el más adecuado aquí o si debe estar en tu App.vue principal -->
        <div class="container mt-2 mb-5">
            <div class="row">
                <div class="col-md-12 text-center mt-5 mb-3">
                    <img :src="require('@/assets/logo-main.webp')"
                         class="img-fluid" width="250" />
                </div>
            </div>

            <div class="row">
                <div class="col-md-12 text-center">
                    <!-- Loading State -->
                    <div v-if="isLoading">
                        <h2>Verificando Receta Médica...</h2>
                        <p>Por favor, espera un momento.</p>
                        <!-- Opcional: Puedes añadir un spinner o una animación Lottie de carga aquí -->
                    </div>

                    <!-- Success State -->
                    <div v-if="verificationStatus === 'success'">
                        <div ref="lottieContainer"
                             style="width: 100%; max-width: 111px; height: auto; aspect-ratio: 1; margin: 0 auto; display: flex; justify-content: center; align-items: center;">
                        </div>
                        <h2 class="text-center mb-3 fw-bold mt-3">Solicitud Verificada Exitosamente</h2>
                        <p>Tu solicitud ha sido validada y fue expedida en Medicynia.</p>
                        <p><strong>Nota:</strong> Tienes un plazo de 72 horas para descargar esta solicitud. Después de este tiempo, ya no estará disponible.</p>
                        <p class="text-center mt-4" style="display: flex; justify-content: center; align-items: center;">
                            <!-- El backend devuelve filePath como /public/nombre-archivo.pdf -->
                            <vs-button color="rgb(59,222,200)" gradient @click.prevent="showPdf">🖨️ Ver Solicitud (PDF)</vs-button>
                        </p>
                        <!-- También podrías incrustar el PDF si lo prefieres: -->
                        <!-- <iframe :src="pdfPath" width="100%" height="600px" class="mt-3"></iframe> -->
                    </div>

                    <!-- Error State -->
                    <div v-if="verificationStatus === 'error'" class="mt-3">
                        <h2 class="text-center mb-3 fw-bold">❌ Error al Verificar Solicitud</h2>
                        <p>La solicitud no existe o ya expiró</p>
                        <!-- Opcional: Puedes añadir un icono de error o una animación Lottie de error aquí -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import axios from 'axios';
    var config = require("@/config/api.json");
    const API = config.api;
    import lottie from 'lottie-web';
    import successAnim from '@/assets/animaciones/success.json'; // Asegúrate que esta ruta es correcta

    export default {
        name: "ImprimirSolicitud", // Cambiado de PagoExitoso
        data() {
            return {
                isLoading: true,
                verificationStatus: 'pending', // 'pending', 'success', 'error'
                errorMessage: '',
                pdfPath: '',
                lottieAnimation: null,
                encryptedUrlFromRoute: '' // Para almacenar el parámetro de la ruta
            };
        },
        async created() {
            // Extraer el parámetro encriptado de la ruta.
            // Es crucial que tu ruta en Vue Router esté definida para capturar este parámetro,
            // por ejemplo: { path: '/imprimir-receta/:encryptedKey', name: 'ImprimirReceta', component: ImprimirReceta }
            // donde ':encryptedKey' es el nombre del parámetro que contiene la cadena encriptada.
            console.log('Creando componente ImprimirReceta');
            const routeParams = this.$route.params;
            const paramName = Object.keys(routeParams)[0]; // Obtiene el nombre del primer parámetro dinámico

            if (paramName && routeParams[paramName]) {
                this.encryptedUrlFromRoute = routeParams[paramName];
            } else {
                // Fallback si no se usan parámetros nombrados explícitamente en la ruta
                // Esto es menos robusto y asume que la parte encriptada es el último segmento.
                const pathParts = this.$route.path.split('/');
                const potentialParam = pathParts[pathParts.length -1];
                // Asegurarse de que no es 'imprimir-receta' si la URL es solo /imprimir-receta
                // y también que no es una cadena vacía si la URL termina con /
                if (potentialParam && potentialParam.toLowerCase() !== 'imprimir-receta' && potentialParam.toLowerCase() !== '') {
                    this.encryptedUrlFromRoute = potentialParam;
                }
            }
            
            if (this.encryptedUrlFromRoute) {
                console.log('Parámetro encriptado de la ruta:', this.encryptedUrlFromRoute);
                await this.verificarRecetaMedica();
            } else {
                console.error('No se encontró el parámetro encriptado en la URL.');
                this.isLoading = false;
                this.verificationStatus = 'error';
                // Mensaje de error más específico para el usuario
                this.errorMessage = 'No se proporcionó el identificador de la receta en la URL. Asegúrate de que la URL tenga el formato correcto: /imprimir-receta/SU_CLAVE_ENCRIPTADA';
            }

            // Lógica para el modo claro/oscuro (conservada y corregida)
            const light = localStorage.getItem('light');
            if (light !== null) {
                // Asegurarse de que 'light' (string "true" o "false") se convierta a booleano
                document.body.classList.toggle('light-mode', light === 'true');
            } else {
                document.body.classList.toggle('light-mode', false); // Default a modo oscuro si no está definido
            }
        },
        methods: {
            async verificarRecetaMedica() {
                if (!this.encryptedUrlFromRoute) {
                    this.isLoading = false;
                    this.verificationStatus = 'error';
                    this.errorMessage = 'Identificador de receta no disponible para verificación.';
                    return;
                }

                this.isLoading = true;
                this.verificationStatus = 'pending'; // Reset status
                this.errorMessage = ''; // Clear previous errors
                try {
                    // El backend espera el parámetro como 'url' en el query string
                    const response = await axios.get(`${API}/verificar-solicitud`, {
                        params: { url: this.encryptedUrlFromRoute }
                    });

                    if (response.data.status === 'success') {
                        this.verificationStatus = 'success';
                        // this.pdfPath se construye con la URL completa del PDF.
                        this.pdfPath = `${API}${response.data.filePath}`;

                        // Esperar a que el DOM se actualice para que lottieContainer esté disponible
                        this.$nextTick(() => {
                            this.playSuccessAnimation();
                        });
                        
                    } else {
                        this.verificationStatus = 'error';
                        this.errorMessage = response.data.message || 'Error desconocido al verificar la receta.';
                    }
                } catch (error) {
                    console.error('Error al conectar con el backend para verificar la receta:', error);
                    this.verificationStatus = 'error';
                    if (error.response && error.response.data && error.response.data.message) {
                        this.errorMessage = error.response.data.message;
                    } else if (error.request) {
                        this.errorMessage = 'No se pudo conectar con el servidor. Verifica tu conexión o la disponibilidad del servicio.';
                    } 
                    else {
                        this.errorMessage = 'Error interno del servidor o problema al procesar la solicitud.';
                    }
                } finally {
                    this.isLoading = false;
                }
            },

            isMobileDevice() {
                return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
            },

            notify(type, message) {
                // Este es un placeholder. Reemplaza con tu sistema de notificaciones (ej. vue-toastification).
                console.log(`Notification (${type}): ${message}`);
                alert(message); // Simple alert para demostración
            },

            showPdf() {
                if (!this.pdfPath) {
                    this.notify('error', 'La URL del PDF no está disponible o aún no se ha cargado.');
                    return;
                }

                const pdfUrl = this.pdfPath; // this.pdfPath ya contiene la URL completa

                if (this.isMobileDevice()) {
                    // En móvil, abrir en una nueva pestaña
                    const link = document.createElement('a');
                    link.href = pdfUrl;
                    link.target = '_blank';
                    link.rel = 'noopener noreferrer';
                    link.click();
                    // this.notify('info', 'El PDF se abrirá en una nueva pestaña.');
                } else {
                    // En escritorio, mostrar en un modal
                    const modal = document.createElement("div");
                    modal.style.position = "fixed";
                    modal.style.top = "0";
                    modal.style.left = "0";
                    modal.style.width = "100%";
                    modal.style.height = "100%";
                    modal.style.backgroundColor = "rgba(0, 0, 0, 0.8)";
                    modal.style.display = "flex";
                    modal.style.justifyContent = "center";
                    modal.style.alignItems = "center";
                    modal.style.zIndex = "1051"; // Bootstrap usa 1050 para modals, así que 1051 está bien.

                    const iframe = document.createElement("iframe");
                    iframe.src = pdfUrl;
                    iframe.style.width = "80%";
                    iframe.style.height = "90%"; // Ajustado para mejor visualización
                    iframe.style.border = "2px solid white";
                    iframe.style.borderRadius = "10px";

                    const closeButton = document.createElement("span");
                    closeButton.innerHTML = "&times;"; // Usar innerHTML para el símbolo '×'
                    closeButton.style.position = "absolute";
                    closeButton.style.top = "15px"; // Ajustado
                    closeButton.style.right = "30px"; // Ajustado
                    closeButton.style.color = "white";
                    closeButton.style.fontSize = "30px"; // Más grande para mejor visibilidad
                    closeButton.style.fontWeight = "bold";
                    closeButton.style.cursor = "pointer";
                    closeButton.addEventListener("click", () => {
                        document.body.removeChild(modal);
                    });

                    modal.appendChild(iframe);
                    modal.appendChild(closeButton);
                    document.body.appendChild(modal);
                }
            },
            playSuccessAnimation() {
                if (this.lottieAnimation) { // Destruye la animación anterior si existe para evitar duplicados
                    this.lottieAnimation.destroy();
                    this.lottieAnimation = null;
                }
                // Asegurarse que el contenedor existe en el DOM y está visible
                if (this.$refs.lottieContainer && this.verificationStatus === 'success') { 
                    this.lottieAnimation = lottie.loadAnimation({
                        container: this.$refs.lottieContainer, // El elemento DOM donde se renderizará
                        renderer: 'svg',
                        loop: false,
                        autoplay: true,
                        animationData: successAnim // Los datos de la animación JSON importados
                    });
                } else if (this.verificationStatus === 'success') {
                    // Solo loguear error si se esperaba que el contenedor existiera
                    console.error("El contenedor para la animación Lottie (lottieContainer) no fue encontrado, aunque el estado es 'success'.");
                }
            }
        },
        beforeDestroy() { // Para Vue 2. Si usas Vue 3, sería beforeUnmount()
            if (this.lottieAnimation) {
                this.lottieAnimation.destroy(); // Limpiar la animación Lottie al destruir el componente
                this.lottieAnimation = null;
            }
        }
    };
</script>

<style scoped>
    /* Estilos anteriores como .blurred pueden ser eliminados si ya no son necesarios */
    .text-danger {
        color: #dc3545; /* Color de peligro de Bootstrap, ajusta si usas otro framework o colores */
    }
    .btn-primary {
        /* Estilos básicos para el botón, puedes personalizarlos */
        display: inline-block;
        font-weight: 400;
        color: #fff;
        text-align: center;
        vertical-align: middle;
        cursor: pointer;
        background-color: #007bff; /* Color primario de Bootstrap */
        border: 1px solid #007bff;
        padding: .375rem .75rem;
        font-size: 1rem;
        line-height: 1.5;
        border-radius: .25rem;
        text-decoration: none;
        transition: color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
    }
    .btn-primary:hover {
        color: #fff;
        background-color: #0056b3; /* Un tono más oscuro para el hover */
        border-color: #0056b3;
    }
</style>